<template>
  <div>
    <b-modal
      size="md"
      id="aufgabeErgebnisFesthaltenModal"
      title="Bitte halte das Ergebnis der Aufgabe fest"
      centered
    >
      <b-form-group label="Ergebnis" style="width: 95%">
        <AppSelect
          v-model="ergebnis"
          :options="kategorien"
          label="Ergebnis"
          placeholder="Ergebnis wählen"
          clearable
        />
      </b-form-group>
      <b-form-group label="Beschreibung" style="width: 95%">
        <b-form-input v-model="ergebnisBeschreibung"></b-form-input>
      </b-form-group>
      <template #modal-footer="{ hide }" class="pl-1">
        <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
        <b-button
          class="dialog-btn"
          :disabled="disableSichernButton"
          variant="primary"
          @click="handleSubmit(hide)"
        >
          Speichern
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import apiService from '@/core/common/services/api.service';
import { mapGetters } from 'vuex';
import AppSelect from '@/components/common/app-select/app-select.vue';

export default {
  components: { AppSelect },
  props: { aufgabeId: { type: Number, required: true }, aufgabenKategorie: { type: String, required: true } },
  computed: {
    ...mapGetters(['getErgebnisKategorienOptions']),
    kategorien() {
      if (this.aufgabenKategorie?.length > 0) {
        const aufgabenKategorieErgebnisOptions = this.getErgebnisKategorienOptions(this.aufgabenKategorie);
        if (aufgabenKategorieErgebnisOptions) {
          return aufgabenKategorieErgebnisOptions.map(option => ({
            value: option.ergebnisKategorie,
            text: option.labelFrontend,
          }));
        }
      }
      return [];
    },
    disableSichernButton() {
      return !this.ergebnis;
    },
  },
  data() {
    return {
      ergebnis: null,
      ergebnisBeschreibung: '',
    };
  },

  methods: {
    handleSubmit(hide) {
      apiService
        .put('/aufgaben/setErgebnis', {
          aufgabeId: this.aufgabeId,
          ergebnis: this.ergebnis,
          ergebnisBeschreibung: this.ergebnisBeschreibung,
        })
        .then(() => {
          hide();
          this.$emit('ergebnisGespeichert');
        });
    },
  },
};
</script>
<style scoped></style>
